import {
  ChangeDetectionStrategy,
  Component,
  input,
  output,
} from '@angular/core';
import { AttachmentModel } from '@fc-vehicles/service/attachment-model';
import { IconComponent } from '@fc-shared/ui/icon/icon.component';
import { forceDownload } from '@fc-core/files-uploads/components/file-card/file-card.component';
import { ButtonComponent } from '@fc-shared/ui/buttons/button.component';
import { MenuComponent } from '@fc-shared/ui/menus/menu.component';
import { MenuItemComponent } from '@fc-shared/ui/menus/menu-item.component';
import { OverlayClickDirective } from '@fc-shared/ui/fc-overlay/overlay-click.directive';

@Component({
  selector: 'fc-media-viewer-header',
  template: `
    <div
      class="flex flex-row items-center justify-between w-full px-24 md:px-30 py-16 md:py-24"
    >
      <div
        class="text-lg font-medium overflow-hidden text-ellipsis whitespace-nowrap text-white"
      >
        {{ file()?.name ?? 'Untitled' }}
      </div>

      <div class="flex flex-row items-center gap-8">
        <ng-content />
        <fc-button
          (click)="downloadFile()"
          variant="icon"
          icon="icon-download"
          color="white"
        />

        <fc-menu>
          <fc-button
            fcOverlayClick
            variant="icon"
            icon="icon-more"
            color="white"
            ariaLabel="More actions"
          />
          <fc-menu-item (click)="openInfo.emit()">
            <fc-icon icon="icon-info-circle" [size]="20" />
            <span>Info</span>
          </fc-menu-item>

          @if (canDelete()) {
            <fc-menu-item (click)="deleteFile.emit()">
              <fc-icon icon="icon-delete" [size]="20" />
              <span>Delete</span>
            </fc-menu-item>
          }
        </fc-menu>

        <fc-button
          (click)="closeDialog.emit()"
          variant="icon"
          icon="icon-close"
          color="white"
        />
      </div>
    </div>
  `,
  imports: [
    IconComponent,
    ButtonComponent,
    MenuComponent,
    MenuItemComponent,
    OverlayClickDirective,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MediaViewerHeaderComponent {
  file = input<AttachmentModel>();
  canDelete = input<boolean>(false);
  openInfo = output<void>();
  closeDialog = output<void>();
  deleteFile = output<void>();

  downloadFile() {
    forceDownload(this.file()?.original, this.file()?.name ?? '');
  }
}
